import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const PieChartDecimal:  any = (props:any) => {
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");

	const {allData, exportExcel, labels, title, idChart, activeButton, colores} = props;

	const options = {
		chart: {
			backgroundColor: '#f0f0f0',
			height: '500',
			colorCount: 15,
			zoomType: 'x',
			plotBackgroundColor: null,
			plotBorderWidth: null,
			plotShadow: false,
			type: 'pie',
		},
		title: {
			text: title
		}
		, subtitle: {
			text: 'Para Ud. en lo personal, el 11 de septiembre de 1973 es una fecha que es importante que todos los políticos, de izquierda y derecha se comprometan con la democracia y el respeto a los derechos humanos.'
		}
		// , tooltip: {
		// 	pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
		// }
		, tooltip: {
			shared: true,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}:  <b>{point.y}%</b></th></tr>',
			pointFormat: '',
			footerFormat: '</table>',
			valueDecimals: 0
		}
		, accessibility: {
			point: {
				valueSuffix: '%'
			}
		},
		plotOptions: {
			pie: {
				dataLabels: {
					enabled: true,
					// @ts-ignore
					formatter: function() {
						// Usa 'this.point.color' para obtener el color del punto
						// @ts-ignore
						return '<span style="color:' + this.point.color + '">'+this.point.name+'<br/>'+ + this.point.percentage.toFixed(0) + '%'  +'</span>';
					},
					distance: 10,
					filter: {
						property: 'percentage',
						operator: '>',
						value: 4
					}
				},
				allowPointSelect: true,
				cursor: 'pointer',
				showInLegend: true
			}
		}
		// , series: allData
		, series: [{        innerSize: '70%', data: allData }]
		// 	[{
		// 		name: 'Si',
		// 		y: 95,
		// 		// sliced: true,
		// 		// selected: true
		// 	},  {
		// 		name: 'No ',
		// 		y: 5
		// 	}]
		// }]
		// , yAxis: {
		// 	title: "enabled"
		// 	, reversed: false,
		// 	labels:{
		// 		format: '{value}%'
		// 	}
		// }
		// , xAxis: {
		// 	categories : labels,
		// 	max: (labels.length - 1)
		// }
		, colors: colores
		, legend: {
			enabled: true
		}
		, credits: {
			enabled: false
		}
		, responsive: {  
			rules: [{  
				condition: {  
				maxWidth: 1000
				},  
				chartOptions: {
				legend: {
					align: 'right',
					verticalAlign: 'bottom',
					layout: 'horizontal'
				},
				
				subtitle: {
					text: 'Para Ud. en lo personal, el 11 de septiembre de 1973 es una fecha que es importante que todos los políticos, de izquierda y derecha se comprometan con la democracia y el respeto a los derechos humanos.'
				},
				credits: {
					enabled: false
				}
			}
			}]  
			},
			
			lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
			},

			exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				}
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"viewFullscreen",
						"printChart",
						"separator",
						"downloadPNG",
						"downloadJPEG",
						"downloadPDF",
						"downloadSVG",
						"separator",
						"label"
					]
				}
			}
		},
	}

    
	// console.log(labels)
    // const options = {
	
	// 	plotOptions: {
	// 		series: {
	// 			dataLabels: {
	// 			align: 'right',
	// 			enabled: true,
	// 			inside: false
	// 			},
	// 			grouping: true
	// 		}
	// 	},
		
	
	// 	series: allData,
	// 	// colors: ['#00A3E0', '#8031A7', '#B5BD00', '#ed8b00', '#09699c', '#ffc000', '#E0004D',
	// 	// 		 '#00C389', '#707372', '#bfbfbf'],
	
	
	
	
	// }

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default PieChartDecimal;
